export default [
  {
    path: "/",
    redirect: "/basic",
  },
  {
    path: "/basic",
    component: () => import("@/layout/BasicLayout.vue"),
    redirect: '/basic/shouye',
    meta: { keepAlive: true },
    children: [
      {
        path: '/basic/shouye',
        component: () => import("@/views/basic/shouye/index.vue"),
        meta: { keepAlive: true, name: 'SHOUYE' },
      },
      {
        path: '/basic/xiaoxi',
        component: () => import("@/views/basic/xiaoxi/index.vue"),
        meta: { keepAlive: true, name: 'XIAOXI' },
      },
      {
        path: '/basic/shoucang',
        component: () => import("@/views/basic/shoucang/index.vue"),
        meta: { keepAlive: true, name: 'SHOUCANG' },
      },
      {
        path: '/basic/wode',
        component: () => import("@/views/basic/wode/index.vue"),
        meta: { keepAlive: true, name: 'WODE' },
      },
      {
        path: '/basic/userAgreement',
        component: () => import("@/views/basic/userAgreement/index.vue"),
        meta: { keepAlive: true, name: 'USERAGREEMENT' },
      },
      {
        path: '/basic/appIntroduction',
        component: () => import("@/views/basic/appIntroduction/index.vue"),
        meta: { keepAlive: true, name: 'APPINTRODUCTION' },
      },
      {
        path: '/basic/privacyAgreement',
        component: () => import("@/views/basic/privacyAgreement/index.vue"),
        meta: { keepAlive: true, name: 'PRIVACYAGREEMENT' },
      },
      {
        path: '/basic/dangan',
        component: () => import("@/views/basic/dangan/index.vue"),
        meta: { keepAlive: true, name: 'DANGAN' },
      },
    ],
  },
  {
    path: "/form",
    component: () => import("@/layout/RouteView.vue"),
    children: [
      {
        path: '/form/nbjl',
        component: () => import("@/views/form/nbjl/index.vue"),
        meta: { name: 'NBJL' },
      },
      {
        path: '/form/qcjl',
        component: () => import("@/views/form/qcjl/index.vue"),
        meta: { name: 'QCJL' },
      },
      {
        path: '/form/wyjl',
        component: () => import("@/views/form/wyjl/index.vue"),
        meta: { name: 'WYJL' },
      },
      {
        path: '/form/ymjl',
        component: () => import("@/views/form/ymjl/index.vue"),
        meta: { name: 'YMJL' },
      },
      {
        path: '/form/ysjl',
        component: () => import("@/views/form/ysjl/index.vue"),
        meta: { name: 'YSJL' },
      },
    ]
  },
  {
    path: "*",
    redirect: "/404",
    component: () => import("@/views/common/404.vue"),
  },
];
